




























































































































































































































































































































































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import SoapDokterSvc from "@/services/SoapRanapDokter";
import SoapPerawatSvc from "@/services/SoapRanapPerawat";
import { userModule } from "@/store/modules/user";
import ModalBatalSoap from "@/components/modal/ModalBatalSoap.vue";
import { appModule } from "@/store/modules/app";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import { SoapRanapResponseItem } from "@/types/soap";
import moment from "moment";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeCopy } from "@/store/modules/copy";
import { storeSoap } from "@/store/modules/soap";
import AsesmenAwalRanapMedisStore from "@/store/modules/AsesmenAwalRanapMedisStore";
import AsesmenAwalRanapKeperawatanStore from "@/store/modules/AsesmenAwalRanapKeperawatanStore";
import { storeRpdDewasa } from "@/store/modules/RpdDewasaStore";
import MonitorTandaVitalChart from "@/components/chart/MonitorTandaVitalChart.vue";
import TandaVitalStore from "@/store/modules/TandaVitalStore";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
import { storePemeriksaanFisikRalan } from "@/store/modules/pemeriksaanfisikralan";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import { isEmpty } from "lodash";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import AsesmenGadarKeperawatanStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarKeperawatanStore";
import { SoapGenerator } from "@/utility/SoapGenerator";
import {
  kandidatSalin,
  cocokSoapPerawat,
  cocokSoapDokterSaya
} from "@/utils/soapSalin";
import { resepStore } from "@/store/modules/resep";
import RencanaAskepSvc from "@/services/RencanaAskep";
import { RencanaAskepResponseItem } from "@/types/cppt";
import { assesmentDariDiagnosa, diagnosaAktif } from "@/utils/askepRencana";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";

@Component({
  components: {
    ModalBatalSoap,
    MonitorTandaVitalChart,
    VCDateTimePicker
  }
})
export default class SoapInput extends Vue {
  @Ref() examinedAtPicker: HTMLElement;
  @Ref() readonly sub;
  @Prop({ default: false }) readonly readonly?: boolean;
  @Prop() value: {
    id: number;
    register_id: number;
    pasien_cm: string;
    unit_id: string;
    subjective: string;
    objective: string;
    assesment: string;
    plan: string;
    instruksi: string;
    examined_at: string;
    verified_at: string;
    copied_from_id: number;
    copied_from_label: string;
    copied_edited: boolean;
  };
  @Prop({ default: false }) isActive?: boolean;

  isFormValid = true;
  validasi = [v => !!v || "*Kolom ini harus diisi"];

  id = null;
  subjective: string = null;
  objective: string = null;
  assesment: string = null;
  plan: string = null;
  instruksi: string = null;
  examinedAt: Date = null;
  verifiedAt: string | Date = null;
  copiedFromId: number = null;
  copiedFromLabel = "";
  copiedSnapshot: Record<string, string> = null;
  copiedEditedStored = false;
  loadingTtv = false;
  dialogSalinSoap = false;
  memuatDiagnosaAskep = false;

  removing = false;
  saving = false;
  verifying = false;

  showBatal = false;

  timePickerProps = { format: "24hr", scrollable: true };
  datePickerProps = { locale: "id", max: moment().format("YYYY-MM-DD") };

  get dateTimeFieldProps() {
    return {
      outlined: true,
      dense: true,
      hint: this.isVerified
        ? "Waktu Pencatatan tidak bisa diubah bila sudah diverifikasi DPJP"
        : null,
      "persistent-hint": this.isVerified
    };
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.examinedAt > dtime) {
      this.$nextTick(() => {
        this.examinedAt = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  @Watch("examinedAt")
  changedExaminedAt(val) {
    if (!val) {
      this.examinedAtPicker["clearHandler"]();
    }
  }

  @Watch("value", {
    deep: true
  })
  changedValue(newVal, oldVal) {
    if (!newVal) {
      this.clearInput();
    } else if (newVal != oldVal) {
      // mode edit / copy soap
      this.id = newVal.id;
      this.subjective = newVal.subjective;
      this.objective = newVal.objective;
      this.assesment = newVal.assesment;
      this.plan = newVal.plan;
      this.instruksi = newVal.instruksi;
      this.examinedAt = newVal.examined_at;
      this.verifiedAt = newVal.verified_at;
      this.copiedFromId = newVal.copied_from_id || null;
      this.copiedFromLabel = newVal.copied_from_label || "";
      this.copiedEditedStored = !!newVal.copied_edited;
      this.copiedSnapshot = this.copiedFromId ? this.snapshotIsiSoap() : null;
    }
  }

  get soapRalanList() {
    return SoapRanapStore.soapList.filter(soap => soap.unit_id < "50");
  }

  get canEditSoap() {
    return this.isNakes && this.id;
  }

  get canMakeSoap() {
    return this.isNakes;
  }

  get isDokter() {
    return ["Dokter", "Psikolog"].includes(this.stateUser.profesi);
  }

  get isNonMedis() {
    return this.stateUser.profesi !== "Dokter" && this.isNakes;
  }

  get isNakes() {
    return this.stateUser.is_nakes;
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get pasienRm(): string {
    return this.$route.params.rm;
  }

  get loadingList(): boolean {
    return SoapRanapStore.loadingList;
  }

  get stateUser() {
    return userModule.user;
  }

  get formatedExaminedAt() {
    return this.examinedAt
      ? moment(this.examinedAt.setSeconds(new Date().getSeconds())).format(
          "YYYY-MM-DD HH:mm:ss"
        )
      : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  private normalisasiIsi(nilai: string) {
    return (nilai || "").replace(/\r\n/g, "\n").trim();
  }

  private snapshotIsiSoap(): Record<string, string> {
    return {
      subjective: this.normalisasiIsi(this.subjective),
      objective: this.normalisasiIsi(this.objective),
      assesment: this.normalisasiIsi(this.assesment),
      plan: this.normalisasiIsi(this.plan),
      instruksi: this.normalisasiIsi(this.instruksi)
    };
  }

  get copiedEdited() {
    if (!this.copiedFromId) return false;
    if (this.copiedEditedStored) return true;
    if (!this.copiedSnapshot) return false;

    const sekarang = this.snapshotIsiSoap();

    return Object.keys(this.copiedSnapshot).some(
      key => this.copiedSnapshot[key] !== sekarang[key]
    );
  }

  get showPenandaSalinan() {
    return !!this.copiedFromId && !this.copiedEdited;
  }

  get input() {
    return {
      register_id: this.registerId,
      pasien_cm: this.pasienRm,
      unit_id: this.id ? this.value.unit_id : this.stateUser.unit_id,
      subjective: this.subjective,
      objective: this.objective,
      assesment: this.assesment,
      plan: this.plan,
      instruksi: this.instruksi,
      copied_from_id: this.copiedFromId,
      copied_edited: this.copiedEdited ? 1 : 0,
      examined_at: this.formatedExaminedAt
    };
  }

  get statusPaste() {
    return storeCopy.copySoap;
  }

  get paste() {
    return storeCopy.pastesoap;
  }

  get statusPasteInstant() {
    return storeCopy.copySoapInstant;
  }

  get soapInstantSave() {
    return storeCopy.soapInstantSave;
  }

  get canPasteAcrossHistory() {
    return this.statusPaste == "1" && this.stateUser.unit_id < "50";
  }

  @Watch("statusPasteInstant")
  changeStatusPasteInstant(val) {
    if (val) {
      this.pasteSoap(this.paste);
    }
  }

  @Watch("soapInstantSave")
  changeSoapInstantSave(val) {
    if (val) {
      this.save();
    }
  }

  private forThisRegister(rec) {
    const reg = rec?.register_id;
    if (reg == null) return rec;
    return String(reg) === String(this.registerId) ? rec : null;
  }

  get asesmenMedisRanap() {
    return this.forThisRegister(AsesmenAwalRanapMedisStore.asesmen);
  }

  get asesmenMedisGadar() {
    return this.forThisRegister(AsesmenGadarMedisStore.asesmen);
  }

  get surveyPrimerGadar() {
    return this.forThisRegister(AsesmenSurveyPrimerGadarStore.asesmen);
  }

  get unitType() {
    let ut = null;

    if (this.stateuser.unit_id == "01") {
      ut = "gadar";
    } else if (this.stateUser.unit_id >= "50") {
      ut = "ranap";
    } else if (this.stateUser.unit_id < "30") {
      ut = "ralan";
    }

    return ut;
  }

  get unitSalinDokter(): boolean {
    const unit = this.stateUser.unit_id;

    return unit >= "50" || unit === "01";
  }

  get modeSalin(): "dokter" | "perawat" {
    return this.isDokter ? "dokter" : "perawat";
  }

  get asesmenSumberDokter() {
    if (!isEmpty(this.asesmenMedisGadar)) return this.asesmenMedisGadar;

    return this.asesmenMedisRanap || null;
  }

  get canGenerateDokter() {
    if (this.readonly || this.id) return false;
    if (!this.isDokter || !this.isNakes || !this.unitSalinDokter) return false;

    return !!this.asesmenSumberDokter || this.soapKandidatSalinDokter.length > 0;
  }

  get labelGenerateDokter() {
    return this.soapKandidatSalinDokter.length
      ? "Salin SOAP Sebelumnya"
      : "Generate dari Asesmen Awal Medis";
  }

  get isPerawat() {
    return ["Perawat", "Bidan"].includes(this.stateUser.profesi);
  }

  get asesmenKeperawatanRanap() {
    const rec = AsesmenAwalRanapKeperawatanStore.asesmen;
    if (!rec || String(rec.register_id) !== String(this.registerId)) {
      return null;
    }
    return rec;
  }

  get rpdDewasa() {
    const rec = storeRpdDewasa.currentItem;
    if (!rec || String(rec.register_id) !== String(this.registerId)) {
      return null;
    }
    return rec;
  }

  get soapKandidatSalin(): SoapRanapResponseItem[] {
    return kandidatSalin(
      SoapRanapStore.soap,
      this.registerId,
      cocokSoapPerawat
    );
  }

  get soapKandidatSalinDokter(): SoapRanapResponseItem[] {
    return kandidatSalin(
      SoapRanapStore.soap,
      this.registerId,
      cocokSoapDokterSaya(this.stateUser.id)
    );
  }

  get canGenerateKeperawatanRanap() {
    if (this.readonly || this.id) return false;
    if (!this.isPerawat || !this.isNakes) return false;

    return !!this.asesmenKeperawatanRanap || this.soapKandidatSalin.length > 0;
  }

  get canGenerateKeperawatan() {
    if (this.readonly || this.id) return false;

    return this.isPerawat && this.isNakes;
  }

  get subtitleSalinSoapSebelumnya() {
    if (this.soapKandidatSalin.length) return "Asesmen awal & log SOAP lampau";
    if (this.asesmenKeperawatanRanap) return "Asesmen awal keperawatan";

    return "Belum ada SOAP perawat sebelumnya / asesmen awal";
  }

  get judulDialogSalin() {
    return this.modeSalin === "dokter"
      ? "Pilih sumber SOAP dokter"
      : "Pilih sumber SOAP keperawatan";
  }

  get adaSumberAsesmen() {
    return this.modeSalin === "dokter"
      ? !!this.asesmenSumberDokter
      : !!this.asesmenKeperawatanRanap;
  }

  get labelSumberAsesmen() {
    return this.modeSalin === "dokter"
      ? "Generate dari Asesmen Awal Medis"
      : "Generate dari Asesmen Awal Keperawatan";
  }

  get subtitleSumberAsesmen() {
    return this.modeSalin === "dokter"
      ? "S/O/A/P dirangkum dari asesmen awal medis + resep aktif"
      : "S/O/A dirangkum dari asesmen awal + TTV terakhir";
  }

  get kandidatSalinAktif(): SoapRanapResponseItem[] {
    return this.modeSalin === "dokter"
      ? this.soapKandidatSalinDokter
      : this.soapKandidatSalin;
  }

  labelSumberSalin(soap: SoapRanapResponseItem) {
    const penulis = soap.user?.nama ?? "-";
    const jam = moment(soap.examined_at).format("DD/MM/YYYY HH:mm");
    const milikSaya =
      String(soap.user_id) === String(this.stateUser.id) ? " (Anda)" : "";

    return `${penulis}${milikSaya} — ${jam}`;
  }

  cuplikanSumberSalin(soap: SoapRanapResponseItem) {
    const teks = [soap.subjective, soap.objective, soap.assesment, soap.plan]
      .filter(bagian => !!bagian)
      .join(" · ")
      .replace(/\s+/g, " ");

    return teks.length > 120 ? `${teks.slice(0, 120)}…` : teks || "-";
  }

  async generateSoapKeperawatanRanap() {
    if (this.soapKandidatSalin.length) {
      this.dialogSalinSoap = true;
      return;
    }

    await this.terapkanGenerateKeperawatan(null);
  }

  async generateSoapDokter() {
    if (this.soapKandidatSalinDokter.length) {
      this.dialogSalinSoap = true;
      return;
    }

    await this.terapkanGenerateDokter(null);
  }

  async pilihSumberSalin(sumber: SoapRanapResponseItem) {
    this.dialogSalinSoap = false;

    if (this.modeSalin === "dokter") {
      await this.terapkanGenerateDokter(sumber);
      return;
    }

    await this.terapkanGenerateKeperawatan(sumber);
  }

  private async terapkanGenerateDokter(sumber: SoapRanapResponseItem) {
    const adaIsian =
      !!this.subjective || !!this.objective || !!this.assesment || !!this.plan;
    const pesan =
      "Isian SOAP yang sekarang akan ditimpa hasil generate. Lanjutkan?";

    if (adaIsian && !confirm(pesan)) return;

    if (!sumber) {
      if (!isEmpty(this.asesmenMedisGadar)) {
        await this.generateSoapFromAsesmenGadar();
      } else {
        await this.generateSoapFromAsesmenRanap();
      }

      return;
    }

    this.applySoapData(SoapGenerator.generateFromPreviousSoap(sumber));
    this.instruksi = sumber.instruksi || null;

    this.copiedFromId = sumber.id;
    this.copiedFromLabel = sumber.examined_at
      ? ` (${moment(sumber.examined_at).format("DD-MM-YYYY HH:mm")})`
      : "";
    this.copiedEditedStored = false;
    this.copiedSnapshot = this.snapshotIsiSoap();

    appModule.sendSuccessNotice(
      `SOAP disalin dari catatan ${this.labelSumberSalin(sumber)}. ` +
        "Periksa & sesuaikan sebelum disimpan."
    );
  }

  private async terapkanGenerateKeperawatan(sumber: SoapRanapResponseItem) {
    const adaIsian =
      !!this.subjective || !!this.objective || !!this.assesment || !!this.plan;
    const pesan =
      "Isian SOAP yang sekarang akan ditimpa hasil generate. Lanjutkan?";

    if (adaIsian && !confirm(pesan)) return;

    const data = sumber
      ? SoapGenerator.generateFromPreviousSoap(sumber)
      : SoapGenerator.generateFromRanapKeperawatan(
          this.asesmenKeperawatanRanap,
          this.rpdDewasa
        );

    this.applySoapData(data);

    if (!sumber) {
      const baris = await this.ambilBarisTtvTerakhir();
      if (baris)
        this.objective = SoapGenerator.replaceTtvLine(this.objective, baris);

      return;
    }

    this.copiedFromId = sumber.id;
    this.copiedFromLabel = sumber.examined_at
      ? ` (${moment(sumber.examined_at).format("DD-MM-YYYY HH:mm")})`
      : "";
    this.copiedEditedStored = false;
    this.copiedSnapshot = this.snapshotIsiSoap();

    appModule.sendSuccessNotice(
      `SOAP disalin dari catatan ${this.labelSumberSalin(sumber)}. ` +
        "Periksa & sesuaikan sebelum disimpan."
    );
  }

  async generateAssesmentDariAskep() {
    if (this.memuatDiagnosaAskep) return;

    const registerId = this.registerId;
    this.memuatDiagnosaAskep = true;

    let rencana: RencanaAskepResponseItem[] = [];

    try {
      const response = await RencanaAskepSvc.getByRegister(registerId);
      rencana = response.data || [];
    } catch (err) {
      return;
    } finally {
      this.memuatDiagnosaAskep = false;
    }

    if (registerId !== this.registerId) return;

    const daftar = diagnosaAktif(rencana);

    if (!daftar.length) {
      appModule.sendErrorAlert(
        "Belum ada diagnosa keperawatan aktif di Perencanaan Asuhan Keperawatan pasien ini."
      );

      return;
    }

    const hasil = assesmentDariDiagnosa(daftar);
    const isiLama = this.normalisasiIsi(this.assesment);

    if (isiLama && isiLama !== hasil) {
      const lanjut = confirm(
        "Isi kolom Assesment yang sekarang akan diganti dengan diagnosa keperawatan dari Perencanaan Asuhan Keperawatan. Lanjutkan?"
      );

      if (!lanjut) return;
    }

    this.assesment = hasil;

    appModule.sendSuccessNotice(
      `Kolom Assesment diisi dari ${daftar.length} diagnosa keperawatan aktif. ` +
        "Periksa & sesuaikan sebelum disimpan."
    );
  }

  get canGenerateTtvKeperawatan() {
    if (this.readonly) return false;
    if (!this.isPerawat || !this.isNakes) return false;

    return this.unitType == "ranap";
  }

  get ttvTerakhirSebelumSoap() {
    const batas = moment(this.examinedAt || new Date());

    const kandidat = TandaVitalStore.list
      .filter(tv => String(tv.register_id) === String(this.registerId))
      .map(tv => ({
        tv,
        waktu: moment(tv.waktu_periksa, [
          "YYYY-MM-DD HH:mm:ss",
          moment.ISO_8601
        ])
      }))
      .filter(x => x.waktu.isValid() && !x.waktu.isAfter(batas))
      .sort((a, b) => b.waktu.valueOf() - a.waktu.valueOf());

    return kandidat.length ? kandidat[0].tv : null;
  }

  private async ambilBarisTtvTerakhir(): Promise<string> {
    const adaRegisterIni = this.ttvList.some(
      tv => String(tv.register_id) === String(this.registerId)
    );

    if (!adaRegisterIni) {
      await TandaVitalStore.getByRegister(this.registerId);
    }

    return SoapGenerator.formatTtvMonitor(this.ttvTerakhirSebelumSoap);
  }

  async generateTtvKeperawatan() {
    const baris = await this.ambilBarisTtvTerakhir();

    if (!baris) {
      appModule.sendErrorAlert(
        "Belum ada pencatatan TTV pada register ini sebelum waktu SOAP. Catat dulu lewat menu Monitor TTV."
      );

      return;
    }

    this.objective = SoapGenerator.replaceTtvLine(this.objective, baris);
  }

  get isVerified() {
    return this.verifiedAt ? true : false;
  }

  async mounted() {
    this.clearInput();
    this.$nextTick(() => {
      this.sub.focus();
    });

    if (this.stateUser.unit_id >= "50" && !this.asesmenMedisRanap) {
      AsesmenAwalRanapMedisStore.getByRegister(this.registerId).catch(
        () => undefined
      );
    }

    if (this.isDokter && this.stateUser.unit_id === "01") {
      const reg = String(this.registerId);

      if (String(AsesmenGadarMedisStore.registerId) !== reg) {
        AsesmenGadarMedisStore.getByRegister(reg).catch(() => undefined);
      }

      if (String(AsesmenSurveyPrimerGadarStore.registerId) !== reg) {
        AsesmenSurveyPrimerGadarStore.getByRegister(reg).catch(
          () => undefined
        );
      }

      if (String(AsesmenGadarKeperawatanStore.registerId) !== reg) {
        AsesmenGadarKeperawatanStore.getByRegister(reg).catch(() => undefined);
      }
    }

    if (this.isPerawat && this.unitType == "ranap") {
      if (
        !this.asesmenKeperawatanRanap &&
        !AsesmenAwalRanapKeperawatanStore.isAnyUnsavedChange
      ) {
        AsesmenAwalRanapKeperawatanStore.getByRegister(this.registerId).catch(
          () => undefined
        );
      }

      if (!this.rpdDewasa) {
        storeRpdDewasa.getByRegister(this.registerId);
      }
    }
  }

  async save() {
    let SoapService = null;

    if (this.isDokter) {
      SoapService = SoapDokterSvc;
    } else if (this.isNonMedis) {
      SoapService = SoapPerawatSvc;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat membuat SOAP selain pengguna yang terdaftar sebagai NaKes"
      );
      return false;
    }

    if (this.showPenandaSalinan) {
      const lanjut = confirm(
        "SOAP ini hasil salinan CPPT sebelumnya. Pastikan isinya sudah diperiksa dan sesuai kondisi pasien saat ini. Simpan?"
      );

      if (!lanjut) return false;
    }

    if (!this.saving) {
      this.saving = true;

      try {
        const isEdit = !!this.id;
        const resp = this.id
          ? await SoapService.update(this.id, this.input)
          : await SoapService.create(this.input);

        if (!this.id) {
          this.id = resp["id"];
        }

        this.clearInput();
        appModule.sendSuccessNotice(
          isEdit ? "SOAP berhasil diubah" : "SOAP berhasil disimpan"
        );

        this.getByRegister();
      } finally {
        this.saving = false;
      }
    }
  }

  get isDisabledInput() {
    if (this.stateuser.unit_id >= "50") {
      const asesmenMedis = AsesmenAwalRanapMedisStore.asesmen,
        unitId = this.stateuser.unit_id,
        isSp = this.stateuser.cdoc?.idsp == "1",
        isDpjp = this.registerKunjungan?.dokter?.id == this.stateUser.id;

      if (isDpjp && !asesmenMedis && unitId >= "50" && isSp) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  get disabledInputMsg() {
    return this.isDisabledInput && !AsesmenAwalRanapMedisStore.asesmen
      ? "Belum bisa membuat SOAP, silahkan isi Asesmen Awal Medis terlebih dahulu!"
      : null;
  }

  async remove(alasan = null) {
    let SoapService = null;

    if (this.isDokter) {
      SoapService = SoapDokterSvc;
    } else if (this.isNonMedis) {
      SoapService = SoapPerawatSvc;
    } else {
      appModule.sendErrorAlert(
        "Tidak dapat menghapus SOAP selain pengguna yang terdaftar sebagai NaKes"
      );
      return false;
    }

    if (!this.removing) {
      this.removing = true;

      try {
        await SoapService.destroy(this.id, alasan?.alasan);

        await this.getByRegister();

        this.clearInput();
      } catch (err) {
        //
      } finally {
        this.removing = false;
      }
    }
  }

  async getByRegister() {
    await SoapRanapStore.getByRegister(this.registerId);

    if (this.stateUser.unit_id < "50") {
      storeSoap.act_soap_on_reg(this.registerId);
    }
  }

  removeHandler() {
    const q = confirm("Menghapus SOAP ini?");

    if (q) {
      this.showBatal = true;
    }
  }

  clearInput() {
    this.id = null;
    this.subjective = null;
    this.objective = null;
    this.assesment = null;
    this.plan = null;
    this.instruksi = null;
    this.examinedAt = null;
    this.verifiedAt = null;
    this.copiedFromId = null;
    this.copiedFromLabel = "";
    this.copiedSnapshot = null;
    this.copiedEditedStored = false;

    this.$emit("input", null);
  }

  formatDate(date) {
    return date ? moment(date).format("DD-MM-YYYY HH:mm") : null;
  }

  pasteSoap(val) {
    if (!this.subjective || !this.objective || !this.assesment || !this.plan) {
      const soap = {
        id: null,
        subjective: val.s,
        objective: val.o,
        assesment: val.a,
        plan: val.p,
        instruksi: val?.instruksi,
        examined_at: null
      };

      this.$emit("input", soap);

      storeCopy.clear_copy_soap();
    } else {
      appModule.sendErrorAlert(
        "Kosongkan semua isian SOAP dahulu untuk menempel riwayat SOAP"
      );
    }
  }

  generateSoap() {
    if (this.unitType == "ranap") {
      this.generateSoapFromAsesmenRanap();
    }

    if (this.unitType == "ralan") {
      this.generateSoapFromAsesmenRalan();
    }

    if (this.unitType == "gadar") {
      this.generateSoapFromAsesmenGadar();
    }
  }

  @Watch("storeAsesmenAwalRalan", { deep: true })
  changestoreAsesmenAwalRalan(v, o) {
    if (v && !this.id && !this.unitSalinDokter) {
      setTimeout(() => {
        this.generateSoapFromAsesmenRalan();
      }, 1000);
    }
  }

  private applySoapData(data: { s: string; o: string; a: string; p: string }) {
    this.subjective = data.s;
    this.objective = data.o;
    this.assesment = data.a;
    this.plan = data.p;

    this.copiedFromId = null;
    this.copiedFromLabel = "";
    this.copiedSnapshot = null;
    this.copiedEditedStored = false;
  }

  // Format resep obat aktif (belum di-stop) milik register ini menjadi teks
  // yang ditambahkan ke Plan, tanpa menghapus rencana terapi yang sudah ada.
  private async appendResepToPlan(p: string): Promise<string> {
    await resepStore.getResepByRegister(this.registerId);

    const lines = resepStore.resep
      .flatMap(resep => resep.items || [])
      .filter((item: any) => !item.stopped_at)
      .map((item: any) => {
        const nama = item.obat_nama || item.nama || "";
        const parts = [nama];
        if (item.ap_dosis) parts.push(item.ap_dosis);
        if (item.rute?.nama) parts.push(item.rute.nama);
        if (item.frekuensi?.nama) parts.push(item.frekuensi.nama);
        return parts.join(" - ");
      });

    if (!lines.length) return p;

    const resepText = "Resep Obat:\r\n" + lines.join("\r\n");
    return p ? `${p}\r\n${resepText}` : resepText;
  }

  async generateSoapFromAsesmenRanap() {
    const data = SoapGenerator.generateFromRanap(this.asesmenMedisRanap);
    data.p = await this.appendResepToPlan(data.p);
    this.applySoapData(data);
  }

  generateSoapFromAsesmenRalan() {
    const data = SoapGenerator.generateFromRalan(
      this.storeAsesmenAwalRalan,
      this.statePemeriksaanFisikRalan,
      this.stateUser.profesi
    );
    this.applySoapData(data);
  }

  async generateSoapFromAsesmenGadar() {
    const data = SoapGenerator.generateFromGadar(
      this.asesmenMedisGadar,
      this.surveyPrimerGadar,
      this.asesmenPerawatGadar
    );
    data.p = await this.appendResepToPlan(data.p);
    this.applySoapData(data);
  }

  get storeAsesmenAwalRalan() {
    return this.forThisRegister(storeAssesmenRalan.asesmenAwal);
  }

  get canGenerateRalan() {
    return (
      !this.unitSalinDokter &&
      this.stateUser.unit_id < "50" &&
      this.soapRalanList.length < 2 &&
      !this.subjective &&
      !this.objective &&
      !this.assesment &&
      !this.plan &&
      !this.instruksi &&
      this.storeAsesmenAwalRalan
    );
  }

  get statePemeriksaanFisikRalan() {
    return this.forThisRegister(
      storePemeriksaanFisikRalan.pemeriksaanfisikralan
    );
  }

  get asesmenPerawatGadar() {
    return this.forThisRegister(AsesmenGadarKeperawatanStore.asesmen);
  }

  get stateuser() {
    return userModule.user;
  }

  showTtvModal() {
    this.showTtvGrafik = true;
  }

  get ttvList() {
    return TandaVitalStore.list;
  }

  get ttvListLoading() {
    return TandaVitalStore.loading;
  }

  get chartSeries() {
    const data = this.ttvList
      // .filter(item => item.unit?.id == userModule.user.unit_id)
      .sort((a, b) => {
        return (
          new Date(a.waktu_periksa).getTime() -
          new Date(b.waktu_periksa).getTime()
        );
      })
      .reduce(
        (result, item) => {
          result.suhu.push({
            x: new Date(item.waktu_periksa),
            y: item.suhu_badan
          });

          result.nadi.push({
            x: new Date(item.waktu_periksa),
            y: item.frekuensi_nadi
          });

          result.nafas.push({
            x: new Date(item.waktu_periksa),
            y: item.frekuensi_nafas
          });

          result.map.push({
            x: new Date(item.waktu_periksa),
            y: item.map
          });

          result.tensi.push({
            x: new Date(item.waktu_periksa),
            y: [item.sistole, item.diastole]
          });

          return result;
        },
        { suhu: [], nadi: [], nafas: [], map: [], tensi: [] }
      );

    return [
      {
        name: "tensi",
        type: "candlestick",
        data: data.tensi
      },
      {
        name: "suhu",
        type: "line",
        data: data.suhu
      },
      {
        name: "nadi",
        type: "line",
        data: data.nadi
      },
      {
        name: "nafas",
        type: "line",
        data: data.nafas
      },
      {
        name: "MAP",
        type: "line",
        data: data.map
      }
    ];
  }

  get dataSet() {
    return {
      labels:
        this.chartSeries
          .find(item => item.name == "tensi")
          ?.data.map(item => moment(item.x).format("yyyy-MM-DD HH:mm")) ?? [],
      tensi:
        this.chartSeries
          .find(item => item.name == "tensi")
          ?.data.map(item => item.y) ?? [],
      suhu:
        this.chartSeries
          .find(item => item.name == "suhu")
          ?.data.map(item => item.y) ?? [],
      nadi:
        this.chartSeries
          .find(item => item.name == "nadi")
          ?.data.map(item => item.y) ?? [],
      nafas:
        this.chartSeries
          .find(item => item.name == "nafas")
          ?.data.map(item => item.y) ?? [],
      mapVal:
        this.chartSeries
          .find(item => item.name == "MAP")
          ?.data.map(item => item.y) ?? []
    };
  }

  get chartWide(): number | undefined {
    return this.dataSet.labels.length > 30
      ? this.dataSet.labels.length * 30
      : undefined;
  }

  get chartWideStr(): string | undefined {
    return this.chartWide ? `${this.chartWide.toString()}px` : undefined;
  }

  showTtvGrafik = false;

  // HARUSNYA SHOW GRAFIK DI DIALOG GAK PERLU FETCH DATA DARI SERVER TERUS MENERUS!!!!
  @Watch("showTtvGrafik")
  changeShowTtvGrafik(val) {
    if (val) {
      this.$nextTick(() => {
        this.reload();
      });
    }
  }

  reload() {
    TandaVitalStore.getByRegister(this.registerId).then(() => {
      document.getElementsByClassName(
        "chart-container"
      )[0].scrollLeft += this.chartWide;
    });
  }

  onClickDatetimePicker() {
    if (this.isVerified) {
      appModule.sendErrorAlert(
        "Waktu Pencatatan tidak bisa diubah bila sudah diverifikasi DPJP!"
      );

      return false;
    }
  }
}
